import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentDetailsView from './PaymentDetails.view';

import enums from '../../../../constants/enums';

export class PaymentDetailsContainer extends Component {

  constructor(props){
    super(props);
    this.state = {
      channelTypes: enums.salesChannelTypes,
      channelStatus: enums.salesChannelStatus,
    };
    this.addChannel = this.addChannel.bind(this);
    this.removeItem = this.removeItem.bind(this);

    this.submitForm = this.submitForm.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
  }

  toggleEdit(){
    const { payment, dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_PAYMENT_EDIT',
    });
    this.setState({
      formState: {
        data: payment,
      }
    });
  }

  onFormUpdate(formState, action) {
    const usingChannel = formState.data.channels && formState.data.channels.find(channel => ['usingCancel', 'usingPurchase'].indexOf(channel.status) > -1);
    const status = usingChannel ? usingChannel.status : formState.data.status;
    this.setState({
      formState: {
        ...formState,
        data: {
          ...formState.data,
          status,
        }
      },
    });
  }

  removeItem(key, index){
    const { formState } = this.state;
    const { data } = formState;

    this.setState({
      formState: {
        ...formState,
        data: {
          ...data,
          [key]: [
            ...data[key].slice(0, index),
            ...data[key].slice(index + 1),
          ]
        }
      }
    });

  }

  addItem(key, value){
    const { formState } = this.state;
    const { data } = formState;
    this.setState({
      formState: {
        ...formState,
        data: {
          ...data,
          [key]: [
            ...data[key],
            value,
          ]
        }
      }
    });
  }

  addChannel(){
    const { channelTypes, channelStatus, formState } = this.state;
    const { data } = formState;
    const { payment } = this.props;
    const now = new Date();
    const day = ('0' + now.getDate()).slice(-2);
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const currentDate = now.getFullYear() + '-' + (month) + '-' + (day);
    const total = formState.data.channels.reduce((sum, channel)=> sum + parseFloat(channel.value), 0);

    this.addItem('channels', );

    this.setState({
      formState: {
        ...formState,
        data: {
          ...data,
          channels: [
            ...data.channels,
            {
              created: currentDate,
              completed: currentDate,
              orderNumber: '',
              type: channelTypes.find(type=> type === 'Raise.com') || channelTypes[0], // default to raise.com
              value: parseFloat(payment.value) - total,
              status: 'sold', //channelStatus[0].value,
            },
          ]
        }
      }
    });
  }

  submitForm(formState) {
    const { dispatch, payment, context, filtersFormState, page } = this.props;
    const { channels, status, code, pin, value, remainingValue } = this.state.formState.data;
    dispatch({
      $global: true,
      type: 'UPDATE_PAYMENT_DETAILS',
      payload: {
        context,
        page,
        filters: filtersFormState && filtersFormState.data,
        _id: payment._id,
        data: {
          channels,
          status,
          code,
          pin,
          value,
          remainingValue,
        }
      }
    });
  }

  render() {
    return (<PaymentDetailsView
      {...this.props}
      {...this.state}
      submitForm={this.submitForm}
      onFormUpdate={this.onFormUpdate}
      removeItem={this.removeItem}
      addChannel={this.addChannel}
      toggleEdit={this.toggleEdit}
    />);
  }

}

function mapStateToProps(state, ownProps) {
  const { paymentDetails, dynamicData } = state;
  return {
    editing: paymentDetails.editing,
    payment: ownProps.payment,
    amazonAccounts: dynamicData.amazonAccounts,
  };
}

export default connect(mapStateToProps)(PaymentDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/PaymentDetails/PaymentDetails.container.js